<template>
  <div
    class="modal"
    :class="[{'is-active': active}, modalClass]"
    v-if="mode">
    <div
      class="modal-background"
      @click.prevent.stop="close"></div>
    <component
      v-if="mode"
      :is="currentComponent"
      ref="innerComponent"
      :source="params.source"
      :active="active"
      :params="params"
      :mode="params.mode"
      :index="params.index"
      @submit="submit"
      @sendInfo="sendInfo"
      @confirm="confirm"
      @close="close"
      class="quickview-block">
    </component>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const MODES = Object.freeze({
  DOCUMENT_EDIT: 'DOCUMENT_EDIT',
  DOCUMENTS_LIST: 'DOCUMENTS_LIST',
  DOCUMENTS_SELECTION: 'DOCUMENTS_SELECTION',
  CANCEL_PROCEDURE: 'CANCEL_PROCEDURE',
  CANCEL_SIGNATURE: 'CANCEL_SIGNATURE',
  DOCUMENT_PREVIEW: 'DOCUMENT_PREVIEW',
  DOCUMENT_PREVIEW_SAAS: 'DOCUMENT_PREVIEW_SAAS',
  DOCUMENT_PREVIEW_ADF: 'DOCUMENT_PREVIEW_ADF',
  YOUSIGN_PREVIEW: 'YOUSIGN_PREVIEW',
  PROMOTEUR_CONTACT: 'PROMOTEUR_CONTACT',
  BUYER_CONTACT: 'BUYER_CONTACT',
  REPLACE_BUYER_CONTACT: 'REPLACE_BUYER_CONTACT',
  BUYER_CONTACT_PRERESA: 'BUYER_CONTACT_PRERESA',
  PARKING_INFO: 'PARKING_INFO',
  NOTAIRE_CONTACT: 'NOTAIRE_CONTACT',
  VIDEO_PREVIEW: 'VIDEO_PREVIEW',
  CREATE_TICKET: 'CREATE_TICKET',
  RECOMMENDED_MANAGEMENT: 'RECOMMENDED_MANAGEMENT',
  EVENT_MODAL: 'EVENT_MODAL',
  EVENT_DOCUMENT_MODAL: 'EVENT_DOCUMENT_MODAL',
  CONTRACT_MODAL: 'CONTRACT_MODAL',
  CONTRACT_SELECT_MODAL: 'CONTRACT_SELECT_MODAL'
})

export default {
  name: 'Modal',
  components: {
    DocumentModalEdit: () => import('../utils/DocumentModalEdit'),
    DocumentsModalList: () => import('./DocumentsModalList'),
    DocumentsSelection: () => import('./DocumentsSelection'),
    CancelProcedure: () => import('./CancelProcedure'),
    CancelSignature: () => import('./CancelSignature'),
    DocumentModalPreview: () => import('../utils/DocumentModalPreview'),
    DocumentPreview: () => import('../utils/DocumentPreview'),
    DocumentPreviewAdf: () => import('../utils/DocumentPreviewAdf'),
    YouSignPreview: () => import('../utils/YouSignPreview'),
    PromoteurEditModal: () => import('./PromoteurEditModal'),
    ContactEditModal: () => import('./ContactEditModal'),
    ContactEditPreResaModal: () => import('./ContactEditPreResaModal.vue'),
    ParkingEditModal: () => import('./ParkingEditModal'),
    NotaireEditModal: () => import('./NotaireEditModal'),
    VideoPreview: () => import('./VideoPreview'),
    CreateTicket: () => import('./CreateTicket'),
    RecommendedManagement: () => import('./RecommendedManagement'),
    EventModal: () => import('./EventModal'),
    EventDocumentModal: () => import('./EventDocumentModal'),
    ContractModal: () => import('./ContractModal'),
    ContractSelectModal: () => import('./ContractSelectModal')
  },
  data () {
    return {
      MODES: MODES,
      mode: null,
      active: false,
      params: {},
      results: {},
      loading: false
    }
  },
  computed: {
    ...mapState(['modal', 'device']),
    currentComponent () {
      const components = {
        [MODES.DOCUMENT_EDIT]: 'DocumentModalEdit',
        [MODES.DOCUMENTS_LIST]: 'DocumentsModalList',
        [MODES.DOCUMENTS_SELECTION]: 'DocumentsSelection',
        [MODES.CANCEL_PROCEDURE]: 'CancelProcedure',
        [MODES.CANCEL_SIGNATURE]: 'CancelSignature',
        [MODES.DOCUMENT_PREVIEW]: 'DocumentModalPreview',
        [MODES.DOCUMENT_PREVIEW_SAAS]: 'DocumentPreview',
        [MODES.DOCUMENT_PREVIEW_ADF]: 'DocumentPreviewAdf',
        [MODES.YOUSIGN_PREVIEW]: 'YouSignPreview',
        [MODES.PROMOTEUR_CONTACT]: 'PromoteurEditModal',
        [MODES.BUYER_CONTACT_PRERESA]: 'ContactEditPreResaModal',
        [MODES.BUYER_CONTACT]: 'ContactEditModal',
        [MODES.REPLACE_BUYER_CONTACT]: 'ContactEditModal',
        [MODES.PARKING_INFO]: 'ParkingEditModal',
        [MODES.NOTAIRE_CONTACT]: 'NotaireEditModal',
        [MODES.VIDEO_PREVIEW]: 'VideoPreview',
        [MODES.CREATE_TICKET]: 'CreateTicket',
        [MODES.RECOMMENDED_MANAGEMENT]: 'RecommendedManagement',
        [MODES.EVENT_MODAL]: 'EventModal',
        [MODES.EVENT_DOCUMENT_MODAL]: 'EventDocumentModal',
        [MODES.CONTRACT_MODAL]: 'ContractModal',
        [MODES.CONTRACT_SELECT_MODAL]: 'ContractSelectModal'
      }
      return components[this.mode]
    },
    modalClass () {
      // Ajoute les classes necessaires sur la modal en fonction des cas
      let classes = []
      if (this.mode === 'DOCUMENTS_SELECTION' || this.mode === 'EVENT_MODAL') classes.push('is-modal-xlarge')
      if (this.mode === 'YOUSIGN_PREVIEW') classes.push('is-modal-xlarge is-modal-fullHeight')
      if ((this.mode === 'DOCUMENT_PREVIEW' || this.mode === 'DOCUMENT_PREVIEW_SAAS' || this.mode === 'DOCUMENT_PREVIEW_ADF') && this.device === 'desktop') classes.push('is-modal-xlarge is-modal-fullHeight')
      if (this.mode === 'PROMOTEUR_CONTACT' || this.mode === 'BUYER_CONTACT' || this.mode === 'REPLACE_BUYER_CONTACT' || this.mode === 'BUYER_CONTACT_PRERESA' || this.mode === 'PARKING_INFO' || this.mode === 'NOTAIRE_CONTACT' || this.mode === 'VIDEO_PREVIEW') classes.push('is-modal-large')
      if (this.mode === 'RECOMMENDED_MANAGEMENT' || this.mode === 'DOCUMENTS_LIST') classes.push('is-modal-slarge')
      // if (this.mode === 'CONTRACT_SELECT_MODAL') classes.push('is-modal-450h is-modal-fullHeight')

      return classes
    }
  },
  watch: {
    modal ({ mode = null, params = null, results = null, keepOpen = false }) {
      if (mode && !results) {
        this.open({ mode, params })
      } else if (!keepOpen) {
        this.close()
      }
    }
  },
  methods: {
    open ({ mode, params }) {
      this.mode = mode
      this.params = Object.assign({}, params)
      this.active = true
    },
    close () {
      this.mode = null
      this.params = null
      this.active = false
    },
    sendInfo (results) {
      this.$store.commit('setModal', { mode: this.mode, params: this.params, results: results, keepOpen: true })
    },
    submit (results) {
      this.$store.commit('setModal', { mode: this.mode, params: this.params, results: results })
      this.close()
    },
    confirm (results) {
      this.$store.commit('setModal', { mode: this.mode, params: this.params, results: results })
      this.close()
    }
  }
}
</script>

<style scoped>
  .is-modal-450h .modal-card{
    height: 450px !important;
  }
</style>
